import { generateJsxKey, parseChildren } from '@utils/ast';
import { video23Printers, video23ToLatexPrinters, video23Parsers } from './spec.23video.js';
import { iGuideHtmlNodeJsxPrinters, iGuideHtmlNodeLatexPrinters, iGuideHtmlNodeParsers } from './spec.html.js';
import { imagePrinters, imageToLatexPrinters, imageParsers } from './spec.image.js';
import { linkPrinters, linkToLatexPrinters } from './spec.link.js';
import { medialibraryPrinters, medialibraryToLatexPrinters, medialibraryParsers } from './spec.medialibrary.js';
import { jsx } from 'react/jsx-runtime';

/**
 * The backend uses a RichTextEditor, which will embed the legacy <font />-tag,
 * when an editor chooses a custom font size. Transform this into a <span />-tag
 * with a specific fontSize applied to it within the frontend.
 */
const parser = (node, context) => {
  const fontSize = (() => {
    switch ((node.getAttribute("size") || "").trim()) {
      case "1":
        return "10px";
      case "2":
        return "13px";
      case "3":
        return "16px";
      case "4":
        return "18px";
      case "5":
        return "24px";
      case "6":
        return "32px";
      case "7":
        return "48px";
      // No other sizes are supported
    }
  })();
  const color = node.getAttribute("color") || undefined;
  const children = parseChildren(node, {
    ...iGuideHtmlNodeParsers,
    ...imageParsers,
    ...medialibraryParsers,
    ...video23Parsers,
    ...fontParsers
  }, context.depth + 1);
  return {
    nodeType: "font",
    children,
    style: {
      fontSize,
      color
    }
  };
};
const fontParsers = {
  font: parser
};
const fontPrinters = {
  font: (node, context) => {
    return /*#__PURE__*/jsx("span", {
      style: node.style,
      children: context.printChildren(node.children, {
        ...iGuideHtmlNodeJsxPrinters,
        ...imagePrinters,
        ...medialibraryPrinters,
        ...video23Printers,
        ...fontPrinters,
        ...linkPrinters
      })
    }, generateJsxKey(context));
  }
};
const fontToLatexPrinters = {
  font: (node, context) => {
    return context.printChildren(node.children, {
      ...iGuideHtmlNodeLatexPrinters,
      ...imageToLatexPrinters,
      ...medialibraryToLatexPrinters,
      ...video23ToLatexPrinters,
      ...linkToLatexPrinters,
      ...fontToLatexPrinters
    }).join("");
  }
};

export { fontParsers, fontPrinters, fontToLatexPrinters };
//# sourceMappingURL=spec.font.js.map
